import * as React from 'react';
import { FunctionComponent } from 'react';
import CapitalizedButton from '../custom-grouping/components/common/CapitalizedButton';

type IActionSectionProps = {
  isCoverageYearOver: boolean;
  isEligibilityDetailsExist: boolean;
  gotoDashboard: () => void;
  onSaveAndContinue: () => Promise<void>;
}

const ActionButtons: FunctionComponent<IActionSectionProps> = ({
  isCoverageYearOver,
  isEligibilityDetailsExist,
  gotoDashboard,
  onSaveAndContinue,
}) => {

  return (
    <div className="controls-container">
      <div className="grid-row controls">
        <div className="tablet:grid-col-6">
          <CapitalizedButton
            type='button'
            id='go-to-dashboard'
            variant={'secondary'}
            labelId={'button.go_to_dashboard'}
            onClickHandler={gotoDashboard}
          />
        </div>
        {
          isEligibilityDetailsExist && !isCoverageYearOver &&
            <div className="tablet:grid-col-6 buttons-group txt-right">
                <CapitalizedButton
                    type='button'
                    id='save-and-continue'
                    labelId={'indportal.tobacco.saveContinue'}
                    onClickHandler={onSaveAndContinue}
                />
            </div>
        }
      </div>
    </div>
  );
};

export default ActionButtons;